import React from "react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import Hero from "../components/Hero/Hero";

import Homesection1 from "../components/home/homesection1/homesection1";
import Homesection2 from "../components/home/homesection2/homesection2";
import Homesection3 from "../components/home/homesection3/homesection3";
import Homesection5 from "../components/home/homesection5/homesection5";
import HomePageDivider from "../components/home/HomePageDivider/HomePageDivider";
import DividerImg from "../assets/hologram_2.jpg";
import SEO from "../components/SEO";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation("global");
  return (
    <>
      <SEO slug="" />
      <Navbar />
      <Hero />

      <Homesection1 />
      <Homesection2 />
      <Homesection3 />

      <HomePageDivider
        DividerImg={DividerImg}
        title={t("pages.home.title")}
        description={t("pages.home.description")}
      />
      <Homesection5 />
      <Footer />
    </>
  );
};

export default Home;
